import DropdownMenu from "../../../ui/components/DropdownMenu/DropdownMenu";

import DownloadAgreementDropdownItem from "./items/DownloadAgreementDropdownItem";
import RenewAgreementDropdownItem from "./items/RenewAgreementDropdownItem";
import ViewAgreementDropdownItem from "./items/ViewAgreementDropdownItem";
import ViewAgreementSecondPartyDropdownItem from "./items/ViewAgreementSecondPartyDropdownItem";

export default function AgreementDropdownMenu({ agreement, hideViewOption = false }) {
	return (
		<DropdownMenu>
			{() => (
				<>
					{!hideViewOption && <ViewAgreementDropdownItem agreement={agreement} />}

					<DownloadAgreementDropdownItem agreement={agreement} />

					<ViewAgreementSecondPartyDropdownItem agreement={agreement} />

					<RenewAgreementDropdownItem agreement={agreement} />
				</>
			)}
		</DropdownMenu>
	);
}
